import * as Yup from 'yup';

const createCollaboratorSchema = Yup.object().shape({
  email: Yup.string().email('errors.emailInvalid').required('errors.emailRequired'),
  permissions: Yup.array().of(Yup.string()).min(1).required('errors.permissionsRequired')
});

export { createCollaboratorSchema };
